import * as React from 'react';
import { SelectItem } from '../types';
import { MdClose } from 'react-icons/md';
import { keyCode } from 'ui/common/key-code-types';
import { insertOptionalWordbreaks } from 'app/infrastructure/platform';

import styles from './selected-option.scss';

export interface SelectedOptionProps {
  item: SelectItem;
  onClick?: (item: SelectItem) => void;
  onRemove: (item: SelectItem) => void;
  readOnly?: boolean;
  hasError?: boolean;
}

export class SelectedOption extends React.Component<SelectedOptionProps>{
  private onRemove = (e: any) => {
    e.stopPropagation();
    this.props.onRemove(this.props.item);
  }

  private onClick = () => {
    if (this.props.onClick && !this.props.readOnly) {
      this.props.onClick(this.props.item);
    }
  }

  private onKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.keyCode === keyCode.Enter || e.keyCode === keyCode.Space) {
      e.preventDefault();
      this.onRemove(e);
    }
  }

  public render() {

    const { readOnly, onRemove, hasError, item } = this.props;
    const { description } = item;

    return (
      item?.active === false
        ? null
        : <span className={`
      ${styles.selectTag} 
      ${readOnly ? styles.readOnly : ''}
      ${onRemove ? '' : styles.notRemovable}
      ${hasError ? styles.error : ''}`}
          onClick={this.onClick}>

          <span>
            {insertOptionalWordbreaks(description)}
          </span>
          {onRemove &&
            <i className={`${styles.selectTagRemove} material-icons`}
              onKeyUp={this.onKeyDown}
              onClick={this.onRemove}
              tabIndex={0}
            ><MdClose />
            </i>
          }
        </span>
    );
  }
}
